// extracted by mini-css-extract-plugin
export default {"container":"src-signer-app-pages-reassign-complete-reassign-complete-module__container--29Ote"};